<template>
  <div class="black-inputs discount-day">

    <el-row>
      <el-row class="dateChooser" :gutter="5">
        <el-input class="discountName" v-model="name" placeholder="Nom de la réduction"></el-input>
        <!-- <el-input  class="discountDesc"  v-model="desc" :autosize="{ minRows: 3}" type="textarea" placeholder="Description de l'évènement"></el-input> -->
      </el-row>
      <el-row class="dateChooser" :gutter="5">
        <el-col :span="24">
          <el-date-picker class="datePicker" ref="picker" v-model="dates" type="daterange" @change="cleanDays()"
            range-separator="au" start-placeholder="Date de début" end-placeholder="Date de fin" format="dd/MM/yyyy" />
        </el-col>
      </el-row>
    </el-row>
    <el-row>
      <el-col>
        <el-row v-for="day in labelDays" :key="day" class="day-row">
          <div style="display: flex; align-items: center; width: 100%;">
            <h2>{{ day }}</h2>
            <div style="margin-left: auto; display: flex; align-items: center;">
              <el-switch v-model="switchStates[day]" @change="handleSwitchChange(day)" active-color="#00cec0"
                inactive-color="#e95d5d">
              </el-switch>
            </div>
          </div>
          <el-row v-if="daysData[day] && daysData[day].length > 0" :gutter="20" style="margin-bottom: 20px;">
            <el-col :span="7">
              Heure de début
            </el-col>
            <el-col :span="7">
              Heure de fin
            </el-col>
            <el-col :span="7">
              Taux de réduction (%)
            </el-col>
          </el-row>
          <el-col :span="24" v-for="(range, index) in daysData[day]" :key="index" style="margin-bottom: 10px;">
            <el-row :gutter="20">
              <el-col :span="7">
                <el-time-select v-model="range.hourStart" placeholder="Sélectionner l'heure de début" format="HH:mm"
                  :clearable="false"
                  :picker-options="getPickerOptions(day, range.hourStart, range.hourEnd, isStart = true, index)"></el-time-select>
              </el-col>
              <el-col :span="7">
                <el-time-select v-model="range.hourEnd" placeholder="Sélectionner l'heure de fin" format="HH:mm"
                  :clearable="false"
                  :picker-options="getPickerOptions(day, range.hourStart, range.hourEnd, isStart = false, index)"></el-time-select>
              </el-col>
              <el-col :span="7">
                <el-select v-model="range.discount" placeholder="Taux de réduction (%)">
                  <el-option v-for="percent in discountOptions" :key="percent" :label="percent + '%'" :value="percent">
                  </el-option>
                </el-select>
              </el-col>
              <el-col :offset="1" :span="2">
                <el-button type="danger" icon="el-icon-delete" @click="removeTimeRange(day, index)"></el-button>
              </el-col>
            </el-row>
          </el-col>
          <el-col :span="24">
            <el-row>
              <el-button v-if="disableAddTimeBtn(day)" class="dark" icon="el-icon-plus" @click="addTimeRange(day)" />
            </el-row>
          </el-col>
        </el-row>
      </el-col>
    </el-row>
    <el-row v-loading="loading">
      <el-col :span="7" :offset="9">
        <el-button class="dark" type="primary" @click="closeDialog()">Annuler</el-button>
      </el-col>
      <el-col :span="7" :offset="1">
        <el-button type="primary" @click="validModifications()">Valider</el-button>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { Notification } from 'element-ui';
import cloneDeep from 'lodash/cloneDeep';
import { mapActions, mapGetters, mapMutations } from 'vuex';

export default {
  name: 'DiscountEdit',
  data() {
    return {
      dates: {},
      daySelected: [],
      labelDays: ['Lundi', 'Mardi', 'Mercredi', 'Jeudi', 'Vendredi', 'Samedi', 'Dimanche'],
      name: '',
      desc: '',
      daysData: {
        Lundi: [],
        Mardi: [],
        Mercredi: [],
        Jeudi: [],
        Vendredi: [],
        Samedi: [],
        Dimanche: []
      },
      discountOptions: [5, 10, 15, 20, 25, 30, 35, 40, 45, 50],
      switchStates: {},
      loading: false
    }
  },
  computed: {
    ...mapGetters({
      isVisibleDialogEditDiscount: 'displayer/isVisibleDialogEditDiscount',
      getSelectedDiscount: 'discount/getSelectedDiscount'
    })
  },
  methods: {
    ...mapActions({
      createDiscount: 'discount/createDiscount'
    }),
    ...mapMutations({
      setDialogEditDiscount: 'displayer/setDialogEditDiscount',
      setSelectedDiscount: 'displayer/setSelectedDiscount',
      clearSelectedDiscount: 'discount/clearSelectedDiscount'
    }),
    initDiscountData() {
      if (this.getSelectedDiscount) {
        this.name = this.getSelectedDiscount.name
        this.desc = this.getSelectedDiscount.desc
        this.dates = cloneDeep(this.getSelectedDiscount.dates)

        this.labelDays.forEach(day => {
          this.$set(this.daysData, day, cloneDeep(this.getSelectedDiscount[day]))
          this.$set(this.switchStates, day, this.getSelectedDiscount[day].length > 0)
        })
      } else {
        this.name = ''
        this.desc = ''
        this.dates = {}
        this.labelDays.forEach(day => {
          this.$set(this.daysData, day, [])
          this.$set(this.switchStates, day, false)
        })
      }
    },
    initializeDaysData() {
      this.labelDays.map(day => {
        this.$set(this.daysData, day, [])
        this.$set(this.switchStates, day, this.daysData[day].length > 0)
      })
    },
    addTimeRange(day) {
      this.daysData[day].push({ hourStart: '', hourEnd: '', discount: 5 })
    },
    removeTimeRange(day, index) {
      this.daysData[day].splice(index, 1)
      if (this.daysData[day].length === 0) {
        this.switchStates[day] = false
      }
    },
    cleanDays() {
      this.daySelected = []
    },
    editDay(day) {
      if (this.daySelected.includes(day)) {
        this.daySelected = this.daySelected.filter(d => d !== day)
      } else {
        this.daySelected.push(day)
      }
    },
    disableAddTimeBtn(day) {
      return this.switchStates[day] && this.daysData[day].length > 0 && this.daysData[day].slice(-1)[0].hourEnd !== '' && this.daysData[day].slice(-1)[0].hourEnd !== '23:00' && this.daysData[day].slice(-1)[0].hourEnd !== '23:30'
    },
    getPickerOptions(day, startTime, endTime, isStart, index) {
      const step = '00:30'

      const findNextOrPreviousStep = (time, direction) => {
        let [stepHour, stepMinute] = step.split(':').map(Number)
        let [hour, minute] = time.split(':').map(Number)
        minute += stepMinute * direction
        hour += stepHour * direction

        if (minute >= 60) {
          hour += Math.floor(minute / 60)
          minute = minute % 60
        } else if (minute < 0) {
          hour -= Math.ceil(Math.abs(minute) / 60)
          minute = 60 + (minute % 60)
        }

        return `${hour.toString().padStart(2, '0')}:${minute.toString().padStart(2, '0')}`
      }

      const previousIndexEndHour = this.daysData[day][index - 1] && this.daysData[day][index - 1].hourEnd ? this.daysData[day][index - 1].hourEnd : undefined
      const nextIndexStartHour = this.daysData[day][index + 1] && this.daysData[day][index + 1].hourStart ? this.daysData[day][index + 1].hourStart : undefined

      let start = '05:30'
      let end = '23:30'

      if (isStart) {
        end = findNextOrPreviousStep(endTime || end, -1)
        start = previousIndexEndHour || start
        if (index !== 0) start = findNextOrPreviousStep(start, 1)
      } else {
        end = nextIndexStartHour ? findNextOrPreviousStep(nextIndexStartHour, -1) : end
        start = startTime || findNextOrPreviousStep((previousIndexEndHour || start), 1)
        start = findNextOrPreviousStep(start, 1)
      }

      return {
        start,
        step,
        end
      }
    },
    handleSwitchChange(day) {
      if (!this.switchStates[day]) {
        if (this.daysData[day].length > 0) {
          this.daysData[day] = []
        }
      } else {
        if (this.daysData[day].length === 0) {
          this.daysData[day].push({ hourStart: '', hourEnd: '', discount: 5 })
        }
      }
    },
    validModifications: function () {
      const cleanedDaysData = {}
      this.labelDays.forEach(day => {
        cleanedDaysData[day] = this.daysData[day].filter(range => {
          return range.hourStart && range.hourEnd && (range.discount !== null && range.discount !== '')
        })
      })

      this.createDiscount({
        name: this.name,
        desc: this.desc,
        dates: this.dates,
        Lundi: cleanedDaysData.Lundi,
        Mardi: cleanedDaysData.Mardi,
        Mercredi: cleanedDaysData.Mercredi,
        Jeudi: cleanedDaysData.Jeudi,
        Vendredi: cleanedDaysData.Vendredi,
        Samedi: cleanedDaysData.Samedi,
        Dimanche: cleanedDaysData.Dimanche
      }).then((res) => {
        this.closeDialog()
        Notification.success({
          title: 'Réduction sauvegardée',
          message: res.name,
          position: 'bottom-right'
        })
      }).catch(err => {
        Notification.error({
          title: 'Erreur',
          message: err.message.message,
          position: 'bottom-right'
        })
        console.error(err)
      })
    },
    closeDialog: function () {
      this.loading = false
      this.setDialogEditDiscount(false)
      this.clearSelectedDiscount()
    }
  },
  created: function () {
    this.initDiscountData()
  },
  watch: {
    'isVisibleDialogEditDiscount': function (val, oldVal) {
      if (val === true) {
        this.initDiscountData()
      }
    }
  }
}
</script>

<style lang="scss">
.cashOption {
  .el-input {
    width: 80%;
    margin: auto;
  }
}

.discountName,
.discountDesc {
  margin: auto;
  display: block;
  margin-bottom: 16px;
}

.day-row {
  background-color: var(--dark__main_color-low);
  border-radius: 24px;
  margin-bottom: 16px;
  padding: 8px 16px;
}

.discount-day {
  background-color: var(--dark__main_color);
  border-radius: 15px !important;
  padding: 10px 41px;
  margin-bottom: 20px;
  display: flex;
  flex-direction: column;
  gap: 16px;

}
</style>
